function pushToDataLayer(event, payload, debug = false) {
  // Make sure data layer is available
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  for (let key in payload) {
    if (!payload[key]) {
      delete payload[key];
    }
  }
  logDataLayer(event, payload, debug);
  // Push to data layer
  window.dataLayer.push({
    event: event,
    ...payload,
  });
}

function logDataLayer(eventName, payload, debug = false) {
  if (!debug) return;
  if (process.env.NODE_ENV != "development") return;
  const color = "#ebb434";
  let message = "DataLayer Event: " + eventName;
  message += "\n";
  message += JSON.stringify(payload, null, 2);
  console.log("%c" + message, "color:" + color);
}

export { pushToDataLayer };
